var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Et=require("ttag");module.exports=$CLJS.Et;